import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/orgs')({
  component: RouteComponent,
  loader: () => ({
    crumb: 'Organisations',
  }),
})

function RouteComponent() {
  return <Outlet />
}
